module.exports = __webpack_public_path__ + "img/csm_Ersa-POWERFLUX-01-900x675_c819470ab9.ee939672.png";